import axios from 'axios';

const api = axios.create({
  baseURL: window.env.REACT_APP_API_URL ?? undefined,
});

export const setAuthToken = (token: string) => {
  api.defaults.headers['Authorization'] = token;
};

export default api;
